import React from 'react'
import { useNavigate } from 'react-router-dom'
import { IOperationalAlert } from '../types/operations.types'
import {
  AlertCardStyled,
  AlertHeader,
  AlertTitle,
  AlertTimestamp,
  AlertDesc,
  AlertAction,
  StatusDot,
  opsColors,
} from '../styled/Operations.styled'

interface AlertCardProps {
  alert: IOperationalAlert
}

const formatTimeAgo = (timestamp: string): string => {
  const diff = Date.now() - new Date(timestamp).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  return `${hours}h ago`
}

const severityColor = (severity: string) => {
  if (severity === 'critical') return opsColors.dangerBase
  if (severity === 'warning') return opsColors.warningBase
  return opsColors.infoBase
}

export const AlertCard: React.FC<AlertCardProps> = ({ alert }) => {
  const navigate = useNavigate()

  return (
    <AlertCardStyled severity={alert.severity}>
      <AlertHeader>
        <AlertTitle>
          <StatusDot color={severityColor(alert.severity)} glow />
          {alert.title}
        </AlertTitle>
        <AlertTimestamp>{formatTimeAgo(alert.timestamp)}</AlertTimestamp>
      </AlertHeader>
      <AlertDesc>{alert.description}</AlertDesc>
      <AlertAction onClick={() => alert.actionPath && navigate(alert.actionPath)}>
        {alert.actionLabel}
      </AlertAction>
    </AlertCardStyled>
  )
}
